import { render, staticRenderFns } from "./purchased-item-detail.vue?vue&type=template&id=359a12bf&scoped=true&"
import script from "./purchased-item-detail.vue?vue&type=script&lang=js&"
export * from "./purchased-item-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "359a12bf",
  null
  
)

export default component.exports